import { cancel } from 'redux-saga/effects';
import { SagaIterator, Task } from 'redux-saga';

export function* CancelSagas(tasks: Task[]): SagaIterator {
	for (let i = 0; i < tasks.length; i++) yield cancel(tasks[i] as Task);
}
